import { BidReportQuery } from "lib/generated/app-service-gql/graphql";
import { BidDetails } from "lib/hooks/api/bid/bids/useBid";

// TODO: Long-term plan is to remove this public API and implement graphql federation instead

type BidReport = BidReportQuery["bidReport"];
export type PublicBidReportInfo = Omit<NonNullable<BidReport>, "bid"> & {
  bid:
    | (NonNullable<NonNullable<BidReport>["bid"]> & {
        winThemes: BidDetails["winThemes"];
      })
    | null;
};

/**
 * Fetches bid info (notice, buyer etc.) for a non-logged in user
 * Hopefully got here via share link, if not the API will fail
 * @returns
 */
export async function getBidReportInfoForExternalUser(
  bidReportId: string,
  urlShareSignature: string,
): Promise<PublicBidReportInfo> {
  try {
    const response = await fetch(`${window.app_service_url}/bid-report-api/getBidReportInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ bidReportId, urlShareSignature }),
    });

    if (!response.ok) {
      console.error(`Error: ${response.status} - ${response.statusText}`);
    }

    return (await response.json()) as PublicBidReportInfo;
  } catch (error) {
    console.error(`Failed to fetch bid report info: ${error}`);
    throw error;
  }
}
